import { render, staticRenderFns } from "./uisejifen.vue?vue&type=template&id=1447ed3c&scoped=true&"
import script from "./uisejifen.vue?vue&type=script&lang=js&"
export * from "./uisejifen.vue?vue&type=script&lang=js&"
import style0 from "./uisejifen.vue?vue&type=style&index=0&lang=css&"
import style1 from "./uisejifen.vue?vue&type=style&index=1&id=1447ed3c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1447ed3c",
  null
  
)

export default component.exports